import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOut from "./sections/ReachOut";
import CollabOpportunities from "./sections/CollabOpportunities";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOut />
      <CollabOpportunities />
      <SiteFooter />
    </div>;
}